import { skipToken } from '@reduxjs/toolkit/query';
import clsx from 'clsx';
import { useSelector } from 'react-redux';

import { useGetCompanyByIdQuery } from '@entities/company';

import { selectActiveCompanyId } from '@shared/api/reduxToolkit';
import { AvatarIdentity } from '@shared/ui/avatar';
import { BrandLogo } from '@shared/ui/brandLogo';

import s from './Header.module.css';
import { HeaderNavigation } from '../headerNavigation';
import { HeaderSupport } from '../headerSupport';

export const Header = ({ className = '' }) => {
	const activeCompanyId = useSelector(selectActiveCompanyId);

	const { data: company } = useGetCompanyByIdQuery(
		activeCompanyId ? { companyId: activeCompanyId } : skipToken,
	);

	const companyLogoUrl = company?.logoUrl ?? null;

	return (
		<header className={clsx(s.header, className)}>
			<div className={s.header_container}>
				<div className={s.header_brand}>
					{companyLogoUrl ? (
						<img src={companyLogoUrl} alt='' className={s.header_logo} />
					) : (
						<BrandLogo className={s.header_logo} />
					)}
				</div>

				<div className={s.header_actions}>
					<HeaderSupport />

					<div className={s.header_user_panel}>
						<AvatarIdentity size='sm' mode='auto' />
						<HeaderNavigation />
					</div>
				</div>
			</div>
		</header>
	);
};
